import { render, staticRenderFns } from "./FhCard.vue?vue&type=template&id=4198afe9&scoped=true&"
import script from "./FhCard.vue?vue&type=script&lang=js&"
export * from "./FhCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4198afe9",
  null
  
)

export default component.exports